module.exports = __webpack_public_path__ + "img/family-of-3-whole-body-svgrepo-com.0250b264.svg";